let srcSetSupported: boolean | undefined;

function isSrcSetSupported(): boolean {
    if (typeof srcSetSupported === 'undefined') {
        srcSetSupported = 'srcset' in document.createElement('img');
    }

    return srcSetSupported;
}

export { isSrcSetSupported };
